export default __webpack_public_path__ + "static/media/node.c2e22c63.png";